export default __webpack_public_path__ + "static/media/inspection.966d308b.jpg";